import MuiAvatarGroup from './MuiAvatarGroup';

export default MuiAvatarGroup;
